import { render, staticRenderFns } from "./TextBookReferesnces.vue?vue&type=template&id=0dffb6f0"
import script from "./TextBookReferesnces.vue?vue&type=script&lang=js"
export * from "./TextBookReferesnces.vue?vue&type=script&lang=js"
import style0 from "./TextBookReferesnces.vue?vue&type=style&index=0&id=0dffb6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports